<app-layout-main [pageMetadata]="pageMetadata">
	<div>
		<lib-message [type]="'warning'" [title]="'Access denied'">
			You don't have permissions for this action.
		</lib-message>
	</div>
</app-layout-main>
